<template>
  <v-select
    :label="label ? label : 'Pay Rate Type'"
    :items="payRateTypesList"
    v-model="payRateTypeValue"
    item-text="payRateType"
    item-value="id"
    :rules="[requiredCheck()]"
    :readonly="readonly"
    :disabled='disabled'
    :clearable="clearable ? clearable : false"
    outlined
    :dense="dense ? dense : false"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'label',
    'isRequired',
    'payRateType',
    'disabled',
    'clearable',
    'readonly',
    'dense'
  ],
  computed: {
    ...mapFields('payRateTypes', [
      'payRateTypesList'
    ]),
    payRateTypeValue: {
      get () {
        return this.payRateType
      },
      set (newValue) {
        this.$emit('payRateTypeChangeHandler', newValue)
      }
    }
  },
  created () {
    this.getPayRateTypes()
  },
  methods: {
    ...mapActions('payRateTypes', [
      'getPayRateTypes'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Pay Rate Type')
    }
  }
}
</script>
